const iFrameCssClasses = {
    byXpath: "highlighted-by-xpath",
    visible: "highlighted-by-xpath-visible",
    active: "highlighted-by-xpath-active",
    hovered: "highlighted-by-xpath-hovered"
};

export default iFrameCssClasses;
